module.exports = __webpack_public_path__ + "static/img/404.2845fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/404.png
// module id = T3Hi
// module chunks = 3